// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2kuTu","modalForm":"UpgradeEpcsModal_modalForm__3eXJk","modalFooter":"UpgradeEpcsModal_modalFooter__1_eK-"};